var _g, _path, _path2, _path3, _g2, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePsy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 103,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#change-psy_svg__clip0_425_111158)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#change-psy_svg__clip1_425_111158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.419 0H73.954v47.324h40.465V0z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.571 38.938l.258 11.982-36.69.947c.325-3.861.958-8.44 2.176-10.9a1.2 1.2 0 01.05-.113c.051-.1.106-.202.166-.308 1-1.876 2.341-3.428 4.131-4.105h.002c1.09-.596 2.323-1.1 3.453-1.499 1.13-.4 2.162-.696 2.85-.882.54-.145.87-.219.87-.219.218-.793-.234-3.253-.234-3.253s-1.939 1.026-3.79.329c-2.96-1.117-2.579-6.586-2.579-6.586l-1.482-.698a.347.347 0 01-.09-.576c.776-.7 2.646-2.281 2.737-4 .042-.81-.531-2.27.684-5.4.095-.246.203-.503.322-.771.028-.072.06-.142.094-.212 1.88-4.05 6.863-4.855 9.516-4.033 9.33 2.538 3.86 11.062 11.278 14.512 3.216 1.495 3.308 4.098 3.308 4.098s-1.632 1.23-2.762 1.81c-.287-.9-.859-2.002-1.977-3.14.02.058.746 2.116.629 3.698-1.49.493-3.607.828-6.482.519.022.04.042.08.066.118.198.328.39.655.606.965a4.4 4.4 0 00.738.844c.208.177.432.337.669.481.158.098.321.19.49.27.005 0 .006.002.01.005.008.004.017.006.026.012.868.407 2.175.953 3.983 1.54.077.023.153.048.231.073.157.05.304.123.461.16 2.765.672 4.775 2.215 6.281 4.333l.001-.002z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.41 57.96l2.824 4.192a.751.751 0 001.245-.839l-3.77-5.595a.75.75 0 00-1.04-.203l-5.601 3.773a.75.75 0 10.837 1.243l3.967-2.671c-2.482 7.737-10.419 12.57-18.589 10.98a.75.75 0 00-.287 1.472c9.05 1.761 17.837-3.692 20.415-12.352z",
    fill: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#change-psy_svg__clip2_425_111158)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.247 19.32H.92v85.74h86.327V19.32z",
    fill: "#00B5A6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "change-psy_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 19,
    width: 121,
    height: 87
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.187 19.32H8.372v85.74h119.815V19.32z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#change-psy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.255 39.005s-9.767 16.937-4.722 36.343h4.888l1.421-2.55.958 2.558c17.05.03 37.09.165 37.09.165s3.099-17.13-3.646-34.004c-17.072-5.044-35.991-2.509-35.991-2.509l.002-.004z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.787 66.333s4.66 15.732-.984 17.38c-5.644 1.649-11.946 2.221-11.946 2.221l24.569 24.184L76.064 85.98s-7.575-.609-12.993-2.265c-5.629-1.716-.765-18.57-.765-18.57l-19.517 1.188h-.002z",
    fill: "#fff",
    stroke: "#101828",
    strokeWidth: 0.582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.594 70.628c11.274 0 20.413-9.266 20.413-20.699 0-11.432-9.14-20.699-20.413-20.699-11.274 0-20.411 9.267-20.411 20.7 0 11.432 9.139 20.698 20.41 20.698z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.74 68.08c2.079-.852 2.691-4.125 1.37-7.31-1.325-3.186-4.082-5.077-6.162-4.226-2.08.852-2.692 4.125-1.37 7.31 1.323 3.186 4.082 5.079 6.161 4.226z",
    fill: "#fff",
    stroke: "#101828",
    strokeWidth: 0.582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.03 61.77s-1.793-2.963-4.285-2.113l4.286 2.113z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.03 61.77s-1.793-2.963-4.285-2.113",
    stroke: "#101828",
    strokeWidth: 0.758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.205 64.94s-2.627-2.273-1.855-5.342l1.855 5.342z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.205 64.94s-2.627-2.273-1.855-5.342",
    stroke: "#101828",
    strokeWidth: 0.758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.826 64.058c1.322-3.186.71-6.46-1.37-7.311s-4.839 1.04-6.161 4.225c-1.322 3.186-.71 6.46 1.37 7.311 2.08.853 4.838-1.04 6.163-4.225h-.002z",
    fill: "#fff",
    stroke: "#101828",
    strokeWidth: 0.582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.951 55.596s-3.154 22.189-15.656 22.189c-13.207 0-16.615-22.188-16.615-22.188l.968-7.027L46.2 35h9.547l14.163 16.788",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.951 55.596s-3.154 22.189-15.656 22.189c-13.207 0-16.615-22.188-16.615-22.188l.968-7.027L46.2 35h9.547l14.163 16.788",
    stroke: "#101828",
    strokeWidth: 0.758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.383 61.993s1.794-2.964 4.285-2.113l-4.285 2.113z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.383 61.993s1.794-2.964 4.285-2.113",
    stroke: "#101828",
    strokeWidth: 0.758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.209 65.166s2.627-2.272 1.854-5.342l-1.854 5.342z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.209 65.166s2.627-2.272 1.854-5.342",
    stroke: "#101828",
    strokeWidth: 0.758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.242 52.322s-3.568-3.813-8.029-2.481c-2.02.605-3.51 2.302-3.718 4.387-.422 4.2 2.793 8.628 2.793 8.628l-2.782 2.575",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.242 52.322s-3.568-3.813-8.029-2.481c-2.02.605-3.51 2.302-3.718 4.387-.422 4.2 2.793 8.628 2.793 8.628l-2.782 2.575",
    stroke: "#101828",
    strokeWidth: 0.758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.588 49.556s-4.837-1.446-8.434 3.278l8.434-3.278z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.588 49.556s-4.837-1.446-8.434 3.278",
    stroke: "#101828",
    strokeWidth: 0.758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.884 56.297s3.793-4.711 7.922-.451l-7.922.45z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.884 56.297s3.793-4.711 7.922-.451",
    stroke: "#101828",
    strokeWidth: 0.758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.525 56.219s-3.905-5.03-7.93-.317l7.93.317z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.525 56.219s-3.905-5.03-7.93-.317",
    stroke: "#101828",
    strokeWidth: 0.758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.392 38.274s4.37 11.116 19.634 18.173c3.614-.957 2.046-9.62 2.046-9.62L60.149 32.302l-20.902 2.026s-4.852 15.872-2.71 22.087c9.556-5.506 12.853-18.142 12.853-18.142h.002v.002z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.859 38.184s-1.048 11.207 9.5 14.138c-7.428-4.978-6.222-12.89-6.222-12.89l-.554-2.198-2.724.95z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.565 83.791s2.534 7.851 15.457 7.927c10.654.06 13.302-7.927 13.302-7.927s11.692-.637 19.445 5.895c8.403 7.078 19.194 31.603 19.194 31.603s8.472-12.717 17.971-18.758l11.039 5.798s-4.43 45.391-34.079 42.523c-11.009-1.066-17.23-11.316-17.23-11.316s-4.309 9.416-10.513 8.91H32.159l-12.371 31.87s-25.685-16.979-24.876-40.015c.809-23.035 15.809-45.653 24.267-51.295 9.492-6.33 19.38-5.211 19.38-5.211h.006v-.004z",
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.572 83.328s-1.975 27.261 12.323 26.778c11.778-.398 10.217-26.497 10.217-26.497",
    stroke: "#101828",
    strokeWidth: 0.758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.142 55.062c0 .822-.466 1.49-1.042 1.49-.576 0-1.04-.668-1.04-1.49s.31-.972.887-.972c.576 0 1.196.15 1.196.972h-.002zM61.432 54.859c0 .822-.466 1.49-1.042 1.49-.576 0-1.042-.668-1.042-1.49s.466-1.03 1.042-1.03c.576 0 1.042.206 1.042 1.03z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.145 67.28s4.4 3.942 8.302-.272l-8.302.273z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.145 67.28s4.4 3.942 8.302-.272",
    stroke: "#101828",
    strokeWidth: 0.758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.442 36.358l2.098 2.19c.085.089-.002.234-.121.2l-2.913-.84a5.63 5.63 0 00-5.454 1.344l-2.19 2.098c-.089.085-.234-.002-.2-.121l.841-2.913a5.63 5.63 0 00-1.345-5.454l-2.098-2.19c-.085-.089.002-.234.121-.2l2.913.84a5.63 5.63 0 005.454-1.344l2.19-2.098c.089-.085.234.002.2.121l-.84 2.913a5.63 5.63 0 001.344 5.454zM23.89 45.348l1.418.064c.057.002.075.08.023.107l-1.259.656a2.634 2.634 0 00-1.414 2.22l-.064 1.417c-.002.058-.079.076-.107.024l-.656-1.259a2.634 2.634 0 00-2.22-1.414l-1.417-.063c-.058-.003-.076-.08-.024-.108l1.26-.656a2.634 2.634 0 001.413-2.22l.064-1.417c.002-.058.08-.076.107-.024l.656 1.26a2.634 2.634 0 002.22 1.413z",
    fill: "#FFE36B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.992 13.263L48.17 9.07a.75.75 0 00-1.245.838l3.77 5.596a.75.75 0 001.04.202l5.602-3.772a.75.75 0 10-.838-1.244l-3.967 2.672C55.014 5.625 62.95.793 71.12 2.383A.75.75 0 0071.408.91C62.358-.85 53.57 4.603 50.992 13.263z",
    fill: "#0063A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "change-psy_svg__clip0_425_111158"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v103H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "change-psy_svg__clip1_425_111158"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.954,
    width: 40.465,
    height: 47.324,
    rx: 11.163,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "change-psy_svg__clip2_425_111158"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.977,
    y: 19.488,
    width: 76.744,
    height: 83.513,
    rx: 24.497,
    fill: "#fff"
  })))));
}
export default __webpack_public_path__ + "static/change-psy.47438830.svg";
export { SvgChangePsy as ReactComponent };